export default "__VITE_ASSET__85128570__"